import { render } from "./addPurchaseOrder.vue?vue&type=template&id=2ab2b90c&scoped=true"
import script from "./addPurchaseOrder.vue?vue&type=script&lang=js"
export * from "./addPurchaseOrder.vue?vue&type=script&lang=js"

import "./addPurchaseOrder.vue?vue&type=style&index=0&id=2ab2b90c&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ab2b90c"]])

export default __exports__